// Mesma regra do controller (1 <= atRiskDays < inactiveDays <= 3650, inteiros).
export const isLifecycleRangeValid = (atRiskDays: number | null, inactiveDays: number | null): boolean =>
  Number.isInteger(atRiskDays) && Number.isInteger(inactiveDays)
  && (atRiskDays as number) >= 1 && (atRiskDays as number) < (inactiveDays as number) && (inactiveDays as number) <= 3650

// Enquanto falta um dos dois (1ª carga) o backend devolve o padrão da rede e a tela se preenche;
// com os dois digitados e fora da regra o GET só voltaria 400.
export const canFetchLifecycle = (atRiskDays: number | null, inactiveDays: number | null): boolean =>
  atRiskDays == null || inactiveDays == null || isLifecycleRangeValid(atRiskDays, inactiveDays)
